<template>
  <el-dialog
    :title="productId === '110' ? $t('text.batchCollection') : $t('text.batchDisbursement')"
    :visible="show"
    @close="closeDialog"
    @open="init"
    :close-on-click-modal="false"
    width="600px"
  >
    <!-- 代收   -->
    <el-form :model="form" :rules="rules" ref="form" v-if="productId === '110'">
      <el-form-item
        v-if="ROLE_TYPE.isManager()"
        :label="$t('text.collectionChannel')"
        prop="channelId"
        :label-width="formLabelWidth"
      >
        <el-select
          v-model="form.channelId"
          filterable
          :placeholder="$t('message.chooseOne')"
          :disabled="ROLE_TYPE.isAgent()"
        >
          <el-option
            v-for="item in channelList"
            :key="item.channelId"
            :label="item.channelName"
            :value="item.channelId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.collectionBKashChannel')"
          :label-width="formLabelWidth"
          prop="paymentBKashChannelId"
      ><el-input
          v-model="form.paymentBKashChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.collectionNagadChannel')"
          :label-width="formLabelWidth"
          prop="paymentNagadChannelId"
      ><el-input
          v-model="form.paymentNagadChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.collectionRocketChannel')"
          :label-width="formLabelWidth"
          prop="paymentRocketChannelId"
      ><el-input
          v-model="form.paymentRocketChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>
    </el-form>
    <!-- 代付   -->
    <el-form :model="form" :rules="rules" ref="form" v-if="productId === '120'">
      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.disbursementChannel')"
          prop="withdrawChannelId"
          :label-width="formLabelWidth"
      >
        <el-select
            v-model="form.withdrawChannelId"
            filterable
            :placeholder="$t('message.chooseOne')"
            :disabled="ROLE_TYPE.isAgent()"
        >
          <el-option
              v-for="item in channelList"
              :key="item.channelId"
              :label="item.channelName"
              :value="item.channelId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.disbursementJCChannel')"
          :label-width="formLabelWidth"
          prop="transferBKashChannelId"
      ><el-input
          v-model="form.transferBKashChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.disbursementEPChannel')"
          :label-width="formLabelWidth"
          prop="transferNagadChannelId"
      ><el-input
          v-model="form.transferNagadChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.disbursementRocketChannel')"
          :label-width="formLabelWidth"
          prop="transferRocketChannelId"
      ><el-input
          v-model="form.transferRocketChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="submit" v-if="isButton"
        >{{ $t('text.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  name: "channelEdit",
  props: {
    show: Boolean,
    value: Array,
    action: String
  },
  data() {
    return {
      dialogShow: this.show,
      isButton: true,
      isDisabled: false,
      channelList: [],
      form: {
        productId: "",
        channelId: "",
        paymentBKashChannelId: "",
        paymentNagadChannelId: "",
        paymentRocketChannelId: "",
        withdrawChannelId: "",
        transferBKashChannelId: "",
        transferNagadChannelId: "",
        transferRocketChannelId: "",
      },
      formLabelWidth: "120px",
      rules: {
        channelId: [{ required: true, message: this.$t('message.channelIdRequiredError'), trigger: ["blur", "change"] }],
        withdrawChannelId: [{ required: true, message: this.$t('message.channelIdRequiredError'), trigger: ["blur", "change"] }]
      }
    };
  },
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    },
    productId() {
      return this.action.replace("batch_", "");
    }
  },
  watch: {
    action() {
      this.getChannelList(this.productId);
    }
  },
  methods: {
    init() {},
    closeDialog() {
      this.form = {
        channelId: "",
        paymentBKashChannelId: "",
        paymentNagadChannelId: "",
        paymentRocketChannelId: "",
        withdrawChannelId: "",
        transferBKashChannelId: "",
        transferNagadChannelId: "",
        transferRocketChannelId: "",
      };
      this.$refs["form"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false);
    },
    getChannelList(productId) {
      this.axios
        .get("/routeConfigInfo/selectChannelList", {
          params: {
            productId
          }
        })
        .then((res) => {
          if (res.code === 200) {
            this.channelList = res.data;
          }
        });
    },
    buildBatchParams(forceUpdate) {
      const paymentChannelConfig = {};
      if (this.form.paymentBKashChannelId) paymentChannelConfig.bkash = this.form.paymentBKashChannelId;
      if (this.form.paymentNagadChannelId) paymentChannelConfig.nagad = this.form.paymentNagadChannelId;
      if (this.form.paymentRocketChannelId) paymentChannelConfig.rocket = this.form.paymentRocketChannelId;

      const transferChannelConfig = {};
      if (this.form.transferBKashChannelId) transferChannelConfig.bkash = this.form.transferBKashChannelId;
      if (this.form.transferNagadChannelId) transferChannelConfig.nagad = this.form.transferNagadChannelId;
      if (this.form.transferRocketChannelId) transferChannelConfig.rocket = this.form.transferRocketChannelId;

      return {
        ...this.form,
        paymentChannelConfig: Object.keys(paymentChannelConfig).length > 0 ? JSON.stringify(paymentChannelConfig) : '',
        transferChannelConfig: Object.keys(transferChannelConfig).length > 0 ? JSON.stringify(transferChannelConfig) : '',
        routeIds: this.value.join(","),
        productId: this.productId,
        forceUpdate: !!forceUpdate
      };
    },
    submit() {
      console.log(this.form);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const params = this.buildBatchParams(false);

          this.axios
            .post("/routeConfigInfo/routeConfigInfoUpdateBatch", params)
            .then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: "success"
                });

                this.$bus.$emit("refresh"); //通知刷新

                this.closeDialog();
              } else if ((res.msg || '').includes('通道成本')) {
                const warningMessage = (res.msg || '').replace(/；/g, '<br/>');
                this.$confirm(
                    `<div style="line-height: 1.6; margin-bottom: 12px;">${warningMessage}</div><div>${this.$t('message.confirmForceOperate')}</div>`,
                    this.$t('text.prompt'),
                    {
                      confirmButtonText: this.$t('text.confirm'),
                      cancelButtonText: this.$t('text.cancel'),
                      type: 'warning',
                      dangerouslyUseHTMLString: true,
                    })
                    .then(() => {
                      this.axios.post("/routeConfigInfo/routeConfigInfoUpdateBatch", this.buildBatchParams(true)).then((forceRes) => {
                        if (forceRes.code === 200) {
                          this.$notify({
                            title: this.$t('text.prompt'),
                            message: forceRes.msg,
                            type: "success"
                          });
                          this.$bus.$emit("refresh");
                          this.closeDialog();
                        } else {
                          this.$notify.error({
                            title: this.$t('text.prompt'),
                            message: forceRes.msg
                          });
                        }
                      });
                    })
                    .catch(() => {});
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg
                });
              }
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
